import React, { Component } from 'react';
import FooterComponent from './FooterComponent';
import HeaderLayout from './HeaderLayout';
import BodyLayout from './BodyLayout';


export default class LayoutCore extends Component {
    render() {
        return (
            <div>
                <HeaderLayout />

                {/* Body Layout*/}
                <BodyLayout />


                {/* Footer*/}
                <FooterComponent />
            </div>
        )
    }
}
